import { useEffect, useState } from 'react';
import { usePageTitle } from '../../hooks/usePageTitle';
import SideBar from '../../components/global/SideBar';
import './index.css';
import SpecialistPage from '../../components/specialists/SpecialistPage';
import { fetchPartnersOfType } from '../../services/specialist.service';
import type { PartnerResponse } from '../../services/schedule.service';
import { Loader } from '@beholos/holoscommon';

export default function Finances() {
  usePageTitle('Finanzas - Holos');
  const [partners, setPartners] = useState<PartnerResponse[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setPartners(await fetchPartnersOfType('showFinancialAdvisor'));
      setLoading(false);
    }
    fetchData();
  }, [])

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto">
        {loading ? <Loader /> : <SpecialistPage
          bannerClassName="md:min-h-[auto] min-h-[calc(100vh-80px)]"
          banner={{
            title: 'Asesorías con especialistas en finanzas personales',
            imageUrl:
              'https://image.beholos.com/fit-in/1500x700/filters:quality(50)/img/fitness-pass-v2/banners/financebanner.jpg',
            links: {
              text: 'Agendar Sesión',
              to: 'reservar',
            },
          }}
          icons={[
            {
              icon: 'life/finance/finance-head-1.svg',
              title: 'Control de gastos',
              detail:
                'Aprende a cubrir tus deudas y a manejar tus gastos de manera efectiva e interactiva.',
              height: 60,
            },
            {
              icon: 'life/finance/finance-head-2.svg',
              title: 'Mejora tus finanzas',
              detail:
                'Capacítate para realizar tus presupuestos mensuales y establecer metas a futuro.',
              height: 60,
            },
            {
              icon: 'life/finance/finance-head-3.svg',
              title: 'Aprende a invertir',
              detail:
                'Recibe los mejores consejos para invertir tus ingresos extras a corto y largo plazo.',
              height: 60,
            },
          ]}
          learn={{
            title: "Conversa con un profesional en el tema y aprende:",
            topics: [
              { icon: "finance-help-icon-1.svg", title: "Manejo de presupuestos" },
              { icon: "finance-help-icon-2.svg", title: "Metas financieras" },
              { icon: "finance-help-icon-3.svg", title: "Gestiona tus ingresos y egresos" },
              { icon: "finance-help-icon-4.svg", title: "Gestiona deudas" },
              { icon: "finance-help-icon-5.svg", title: "Oportunidades de inversión" },
              { icon: "finance-help-icon-6.svg", title: "Compras conscientes" },
              { icon: "finance-help-icon-7.svg", title: "Aprendizaje constante" },
              { icon: "finance-help-icon-8.svg", title: "Balances positivos" },
              { icon: "finance-help-icon-9.svg", title: "Ahorro" }
            ]
          }}
          section={{
            title: 'Conoce a nuestros profesionales',
            description:
              'Dependiendo de lo que necesite el usuario se enviarán plantillas para que el usuario pueda tener un mejor control de sus finanzas, como máximo 48 horas después de terminar la sesión. Estas plantillas llegarán por correo electrónico o el medio que le funcione mejor al profesional y al usuario.',
          }}
          specialists={partners.map(partner => ({
            id: partner._id,
            name: partner.name,
            slug: partner.slug,
            imageUrl: `https://image.beholos.com/600x500/filters:quality(90)${partner.otherStudioImages[0]}`,
            countryImageUrl: `https://cache.beholos.com${partner.country?.image}`,
            type: 'Especialista Financiero'
          }))}
        />}
      </div>
    </div>
  );
}
